import { Format } from '@/domain/app';

import { Card, CardExpiryDate, DebitAccount, Organisation, User } from '@generated-types';
import { KortbetjeningText } from '@hooks/use-text';
import { getBankCardName } from '@utils/card-utils';
import { formatAmount } from '@utils/text-format-utils';

import { getOwnerName } from '../card-info-with-functionality/functions';

export const formatExpiryDate = ({ month, year }: CardExpiryDate): string =>
    Number(month) < 10 ? `0${month}/${year % 100}` : `${month}/${year % 100}`;

export const getDebitCardDetails = (
    card: Card,
    text: KortbetjeningText,
    customer: User | Organisation,
    account: DebitAccount,
) => {
    return [
        {
            description: text.overviewDetailsCardOwner,
            value: card.embossedName + card.embossedName2,
        },
        {
            description: text.overviewDetailsCardNumber,
            value: Format.cardNumber(card.number),
        },
        {
            description: text.overviewDetailsProduct,
            value: getBankCardName(card, text),
        },
        {
            description: text.overviewDetailsSaldo,
            value: formatAmount(account?.bookedBalance || 0),
        },
        {
            description: text.overviewDetailsExpires,
            value: formatExpiryDate(card.expirationDate),
        },
        {
            description: text.overviewDetailsAccountNumber,
            value: Format.accountNumber(card.accountNumber),
        },
        {
            description: text.overviewDetailsCardAccountOwner,
            value: customer && getOwnerName(customer),
        },
    ];
};
